// extracted by mini-css-extract-plugin
export var loadingShimmer = "_s5-2";
export var messageContent = "_s5-0";
export var messagesScroll = "_s5-1";
export var shimmer = "_s5-3";
export var shimmerW100 = "_s5-4";
export var shimmerW70 = "_s5-8";
export var shimmerW80 = "_s5-7";
export var shimmerW85 = "_s5-6";
export var shimmerW90 = "_s5-5";